import {useEffect, useState} from 'react';
import {HandleCareTaskModal} from '../../../../../../../../components/task-table/modals/handle-task';
import {PendingTaskModal} from '../../../pending-tasks/modals/pending-task-modal';
import {PlannerItemRegisterData} from '../../body/planner-item';

type PlannerRegisterActivityModalProps = {
  open: boolean;
  data: PlannerItemRegisterData;
  canWrite: boolean;
  onClose: () => void;
  onSave: () => void;
};

export function PlannerRegisterActivityModal(props: PlannerRegisterActivityModalProps) {
  const [isPendingAlert, setPendingAlert] = useState(false);

  useEffect(() => {
    if (
      props.data.user.careTask.rawData.careTask.pendingCareTaskId &&
      !props.data.user.careTask.rawData.careTask.markedAsHandled
    ) {
      setPendingAlert(true);
    }
  }, [
    props.data.user.careTask.rawData.careTask.pendingCareTaskId,
    props.data.user.careTask.rawData.careTask.markedAsHandled,
  ]);

  if (isPendingAlert) {
    return (
      <PendingTaskModal open onValidate={() => setPendingAlert(false)} onClose={props.onClose} />
    );
  }

  return (
    <HandleCareTaskModal
      open
      modalTask={props.data.user.careTask.rawData}
      userId={props.data.user.id}
      onClose={props.onClose}
      setCareTasks={props.onSave}
      canWrite={props.canWrite}
      displayPendingTime={
        !!props.data.user.careTask.rawData.careTask.pendingCareTaskId &&
        !props.data.user.careTask.rawData.careTask.markedAsHandled
      }
    />
  );
}
